<template>
  <pt-roles-form ref="form" class="pt-roles-form__withData" :isEdit="isEdit" :id="id" :permissionsList="permissionsList"
  :rolesList="rolesList" :rolesDetail="rolesDetail" :submitLoading="submitLoading"></pt-roles-form>
</template>

<script>
import PtRolesForm from './form'
export default {
  name: 'pt-roles-form__withData',
  components: {
    'pt-roles-form': PtRolesForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      permissionsList: [],
      rolesList: [],
      rolesDetail: {},
      submitLoading: false
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        if (formValue.userMenus && formValue.userMenus.length > 0) {
          if (this.isEdit) {
            this.rolesEdit(formValue)
          } else {
            this.createdRoles(formValue)
          }
        } else {
          this.$message.error('请选择菜单')
        }
      })
    },
    // 编辑角色
    rolesEdit (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('rolesEdit', data).then(res => {
        this.$emit('submitLoad', false)
        this.$message.success('编辑角色成功')
        history.go(-1)
      }).catch(err => {
        this.$emit('submitLoad', false)
        this.$message.error(err || '编辑角色失败')
      })
    },
    // 新建角色
    createdRoles (data) {
      this.$emit('submitLoad', true)
      this.$store.dispatch('createdRoles', data).then(data => {
        // doing something ...
        this.$emit('submitLoad', false)
        this.$message.success('新建角色成功')
        history.go(-1)
      }).catch(errorMessage => {
        this.$emit('submitLoad', false)
        this.$message.error(errorMessage || '新建角色失败')
      })
    },

    getPermissionsList () {
      this.$store.dispatch('getPermissionsList').then(res => {
        this.permissionsList = res
      }).catch(err => {
        this.$message.error(err || '获取权限列表失败')
      })
    },
    getRolesList () {
      let data = {}
      this.$store.dispatch('rolesList', data).then(res => {
        this.rolesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取角色列表失败')
      })
    },
    getRolesDetail () {
      this.$store.dispatch('rolesDetail', this.id).then(res => {
        this.rolesDetail = res
      }).catch(err => {
        this.$message.error(err || '获取角色详情失败')
      })
    }
  },
  created () {
    this.getPermissionsList()
    this.getRolesList()
    if (this.isEdit) {
      this.getRolesDetail()
    }
  }
}
</script>
